import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Box,
  TableCell,
  TableRow,
  IconButton,
  Select,
  MenuItem,
  Card,
  FormControlLabel,
  Checkbox,
  Tooltip,
} from "@mui/material";
import { ReactComponent as CalenderIcon } from "Assets/Icons/PharmsmartIcon/CalenderIcon.svg";
import { InstallmentDispensingDetail } from "utils/data";
import { ReactComponent as EditIcon } from "Assets/Icons/PharmsmartIcon/EditIcon.svg";
import { ReactComponent as DeleteIcon } from "Assets/Icons/PharmsmartIcon/DeleteIcon.svg";
import { ReactComponent as NoteIcon } from "Assets/Icons/PharmsmartIcon/NoteIcon.svg";
import { ReactComponent as HistoryIcon } from "Assets/Icons/PharmsmartIcon/HistoryIcon.svg";
import { getEllipsisName } from "utils/generalUtils";
import moment from "moment";
import { connect } from "react-redux";
import useViewport from "Hooks/useViewport";
import { useNavigate } from "react-router-dom";
import HtmlTooltipMain from "Components/Common/HtmlTooltipMain";
import { statusMenuItems } from "utils/data";
import { START_STATUS_PATIENT_UPDATE } from "Actions/PatientAction";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import Chips from "Components/Common/Chips";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CustomToolTip from "Components/Common/CustomToolTip";
import clsx from "clsx";

const useStyle = makeStyles((theme) => ({
  rsPatientInfo: {
    display: "flex",
    alignItems: "center",
    "&>div": {
      cursor: "pointer",
      "&:hover": {
        color: "rgba(90, 104, 114, 0.8)",
        cursor: "pointer",
      },
    },

    [theme.breakpoints.down(1500)]: {
      display: "block",
    },
  },
  rsPatientGreyInfo: {
    opacity: "0.6",
    display: "flex",
  },

  rsStatusBox: {
    position: "relative",
    marginBottom: "8px",
    "&>button": {
      cursor: "pointer",
      "&:hover": {
        cursor: "pointer",
      },
    },
  },
  rsStatusmenuList: {
    position: "absolute",
    top: "-10px",
    width: "100px",
    minWidth: "50px",
    left: "10px",
    height: "50px",
    zIndex: "20",
    opacity: "0",
  },

  rsSelectMenulist: {
    width: "54px",
    height: "21px",
    marginTop: "10px",
    marginLeft: "-6px",
    "&>div": {
      padding: "0px !important",
    },
  },
  rsSelectMenulistAction: {
    width: "35px",
    height: "35px",
    marginTop: "10px",
    marginLeft: "-6px",
    zIndex: "20 !important",
    cursor: "pointer",
    "&>div": {
      padding: "0px !important",
    },
  },
  rsMenuAction: {
    display: "flex",
    height: "25px",
    position: "relative",
    alignItems: "center",
    listStyle: "none",
    "&>li": {
      padding: "0px !important",
    },
  },
  iconContainer: {
    display: "flex",
    "&>button": {
      cursor: "default",
    },
  },
  chipMain: {
    display: "flex",
    "&>div": {
      marginRight: "2px",
    },
    "& .MuiChip-label": {
      lineHeight: "15px",
    },
  },
  statusText: {
    marginLeft: "10px !important",
    border: "none !important",
    fontSize: "10px !important",
    height: "20px !important",
    borderRadius: "2px !important",
    [theme.breakpoints.down(1500)]: {
      marginLeft: "0 !important",
      marginTop: "3px",
    },
  },
  textInfo: {
    paddingBottom: "8px !important",
  },
  rsAlignIcon: {
    marginTop: "-5px",
    marginLeft: "45px",
    display: "inline-flex",
  },
  rsPatientNameAlign: {
    display: "flex",
    marginRight: "8px",
    color: "#464646 !important",
    "&:hover": {
      color: "rgba(90, 104, 114, 0.8) !important",
      cursor: "pointer",
    },
  },
  rseditDateIcon: {
    padding: "0px !important",
    width: "18px",
    height: "18px",
    "&>svg": {
      // marginLeft: 10,
      display: "none",
    },
  },
  rsOrderDate: {
    "&>div": {
      height: "25px !important",
      borderRadius: "3px !important",
      lineHeight: "31px !important",
      "&:hover": {
        // background: "rgba(123, 192,  68,0.8) !important",
      },
    },
    "&:hover": {
      lineHeight: "20px",
      cursor: "pointer",
      "&>button": {
        padding: "0px !important",
        "&:hover": {
          backgroundColor: "transparent !important",
          border: `none !important`,
        },
        "&>svg": {
          display: "block",
        },
      },
    },
  },
  rsAddme: {},
  groupColorIcon: {
    padding: "8px",
    margin: "3px",
    width: "10px",
    height: "10px",
    borderRadius: "3px !important",
  },
  cardGroup: {
    background: "#AED581",
    borderRadius: "3px",
    margin: "0px",
    marginLeft: "2px",
    padding: "2px",
    color: "white",
    height: "20px",
    fontSize: "10px",
    padding: "4px 8px",
    fontWeight: "600 !important",
  },
  rsPatientGreyInfoAddress: {
    display: "block",
    //whiteSpace: "normal",
    width: "calc(10vw + 15px)",
  },
  cursorMain: {
    cursor: "text !important",
  },
  tooltip: {
    backgroundColor: "white !important",
    border: "0.5px solid #dadde9",
  },
  remainingTags: {
    color: "#2e5aff",
    cursor: "pointer",
    whiteSpace: "nowrap",
    fontWeight: "400",
    marginLeft: "3px",
  },
}));

const PatientTable = (props) => {
  const {
    i,
    item,
    setShowPatientNoteList,
    setDeletePatient,
    setOpenPatientNoteList,
    setPatientDeleteId,
    getPatientStatusUpdatAction,
    setFilteredPatientId,
    setPatientStatus,
    setOpenPatientHistory,
    setPatientHistory,
    patientStatus,
    filteredPatientId,
    setPatientDetailsId,
    setStatusManage,
    setDetailsDialog,
    setPatientDetails,
    setOrderCount,
    setCollectionCount,
    showDataBasedOnRole,
    tableCells,
    setIsOpenEditDobModel,
    setEditDobDate,
    setPatientDetailOpen,
    setPatientId,
    isItemSelected,
    handleClickTickAction,
    labelId,
  } = props;
  const classes = useStyle();
  const { width } = useViewport();
  const navigate = useNavigate();
  const [openStatusList, setOpenStatusList] = useState(false);

  /**handle status list close */

  const handleStatusClose = () => {
    setOpenStatusList(false);
  };
  /** handle status list open */
  const handleStatusOpen = (e, i, value) => {
    setOpenStatusList(!openStatusList);
  };
  /** handle status list select text  */
  const handleSelectStatustext = (e, value, label) => {
    setPatientDetailsId(item);
    setPatientStatus(label);
    setFilteredPatientId(item?.id);
    handleStatusClose();

    let params = {
      status: value,
    };

    if (value === "active") {
      if (item.order_count === 1 || item.order_count === undefined) {
        setStatusManage(true);
      } else {
        getPatientStatusUpdatAction(item?.id, params);
      }
    } else {
      getPatientStatusUpdatAction(item?.id, params);
    }
  };

  return (
    <TableRow key={i}>
      {/* <TableCell
      >
        <FormControlLabel
          className={classes.labelWhiteSpaceNW}
          checked={isItemSelected}
          control={<Checkbox color="primary" />}
          label=""
          onClick={(event) => {
            handleClickTickAction(event, item, i);
          }}
          inputProps={{
            "aria-labelledby": labelId,
          }}
        />
      </TableCell> */}
      <TableCell semiBold>
        <Box className={classes.iconContainer}>
          <FormControlLabel
            className={classes.labelWhiteSpaceNW}
            checked={isItemSelected}
            control={<Checkbox color="primary" />}
            label=""
            onClick={(event) => {
              handleClickTickAction(event, item, i);
            }}
            inputProps={{
              "aria-labelledby": labelId,
            }}
          />
          <Box className={classes.rsPatientInfo}>
            <Box
              className={
                item?.status === "Absent" || item?.status === "Deceased"
                  ? classes.rsPatientGreyInfo
                  : classes.rsPatientNameAlign
              }
              onClick={(event) => {
                // setDetailsDialog(true);
                // setPatientDetails(item);
                setPatientId(item?.id);
                setPatientDetailOpen(true);
              }}
            >
              {item?.name} {` `}
              {item?.last_name}
            </Box>
          </Box>
        </Box>
        {
          // item?.type ||
          // item?.compliance_aid ||
          // item?.instalment_type ||
          (item?.tags.length > 0 ||
            item?.status !== "Active" ||
            item?.g_tag ||
            (patientStatus !== "" && filteredPatientId == item?.id)) && (
            <Box className={classes.rsAlignIcon}>
              <Box>
                {item?.status && (
                  <Box className={classes.rsStatusBox}>
                    <>
                      {patientStatus !== "" && filteredPatientId == item?.id ? (
                        <Chips
                          key={i}
                          label={patientStatus}
                          color={
                            patientStatus === "Absent"
                              ? "rgba(107, 107, 107,0.6)"
                              : patientStatus === "In-Hospital"
                              ? "rgba(210, 162, 68,0.6)"
                              : patientStatus === "Deceased"
                              ? "rgba(107, 107, 107,0.6)"
                              : //  "rgba(255, 0, 0,0.6)"
                                "rgba(28, 176, 68,0.6)"
                          }
                          onClick={(e, index) => {
                            handleStatusOpen(i);
                          }}
                        />
                      ) : (
                        <>
                          {item?.status !== "Active" && (
                            <Chips
                              key={i}
                              label={item?.status === "" ? null : item?.status}
                              color={
                                item?.status === "Absent"
                                  ? "rgba(107, 107, 107,0.6)"
                                  : item?.status === "In-Hospital"
                                  ? "rgba(210, 162, 68,0.6)"
                                  : item?.status === "Deceased"
                                  ? "rgba(107, 107, 107,0.6)"
                                  : // "rgba(255, 0, 0,0.6)"
                                    "rgba(28, 176, 68,0.6)"
                              }
                              onClick={(e, index) => {
                                handleStatusOpen(i);
                              }}
                            />
                          )}
                        </>
                      )}
                    </>

                    {item?.status !== "Active" ? (
                      <Box className={classes.rsStatusmenuList}>
                        <Select className={classes.rsSelectMenulist}>
                          {statusMenuItems.map((name) => (
                            <MenuItem
                              key={name.value}
                              value={name.label}
                              onClick={(e, value) => {
                                handleSelectStatustext(
                                  e,
                                  name.value,
                                  name.label
                                );
                              }}
                            >
                              {name?.icon ? (
                                <PrimaryIcon
                                  width="20px"
                                  height="20px"
                                  icon={name?.icon}
                                />
                              ) : (
                                <></>
                              )}

                              {name?.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </Box>
                    ) : (
                      <>
                        {patientStatus !== "" &&
                        filteredPatientId == item?.id ? (
                          <Box className={classes.rsStatusmenuList}>
                            <Select className={classes.rsSelectMenulist}>
                              {statusMenuItems.map((name) => (
                                <MenuItem
                                  key={name.value}
                                  value={name.label}
                                  onClick={(e, value) => {
                                    handleSelectStatustext(
                                      e,
                                      name.value,
                                      name.label
                                    );
                                  }}
                                >
                                  {name?.icon ? (
                                    <PrimaryIcon
                                      width="20px"
                                      height="20px"
                                      icon={name?.icon}
                                    />
                                  ) : (
                                    <></>
                                  )}

                                  {name?.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </Box>
                        ) : (
                          <></>
                        )}
                      </>
                    )}
                  </Box>
                )}
              </Box>
              <Box className={classes.chipMain}>
                {item?.g_tag ? (
                  <Box
                    display="flex"
                    className={classes.cardGroup}
                    style={{
                      background: item?.g_color_code,
                    }}
                  >
                    {/* {` (`} */}
                    {/* <Card
                    className={classes.groupColorIcon}
                    style={{
                      background: item?.g_color_code,
                    }}
                  /> */}
                    {` ${item?.g_tag}`}
                    {/* {`)`} */}
                  </Box>
                ) : (
                  ""
                )}
                {item?.tags
                  ?.slice(
                    0,
                    !!(item?.status !== "Active" && item?.g_tag)
                      ? 1
                      : !!(item?.status !== "Active" || item?.g_tag)
                      ? 2
                      : 2
                  )
                  .map((tagvalue, index) => (
                    <Chips
                      key={index}
                      className={classes.cursorMain}
                      rippleEffectEnabled={true}
                      click
                      label={tagvalue?.pit_name}
                      color={
                        item?.status === "Absent" || item?.status === "Deceased"
                          ? "rgba(107, 107, 107, 0.6)"
                          : tagvalue?.pit_colour_code
                      }
                    />
                  ))}
                {item?.tags?.length >
                  (!!(item?.status !== "Active" && item?.g_tag) ? 1 : 2) && (
                  <Tooltip
                    // open={true}
                    classes={{ tooltip: classes.tooltip }}
                    title={
                      <Box>
                        {item?.tags
                          ?.slice(
                            !!(item?.status !== "Active" && item?.g_tag) ? 1 : 2
                          )
                          .map((tagvalue, index) => (
                            <Chips
                              key={index}
                              className={classes.cursorMain}
                              // rippleEffectEnabled={true}
                              click
                              label={tagvalue?.pit_name}
                              color={tagvalue?.pit_colour_code}
                            />
                          ))}
                      </Box>
                    }
                  >
                    <Box className={classes.remainingTags}>
                      {`+${
                        item?.tags?.length -
                        (!!(item?.status !== "Active" && item?.g_tag) ? 1 : 2)
                      }`}
                    </Box>
                  </Tooltip>
                )}

                {/* {item?.type === "collection" && (
                <Chips
                  className={classes.cursorMain}
                  rippleEffectEnabled={true}
                  click
                  label="Collection"
                  color={
                    item?.status === "Absent" || item?.status === "Deceased"
                      ? "rgba(107, 107, 107,0.6)"
                      : "#429600"
                  }
                />
              )} */}
                {/* {item?.type === "delivery" && (
                <Chips
                  className={classes.cursorMain}
                  rippleEffectEnabled={true}
                  click
                  label="Delivery"
                  color={
                    item?.status === "Absent" || item?.status === "Deceased"
                      ? "rgba(107, 107, 107,0.6)"
                      : "rgba(218, 120, 32, 0.6) "
                  }
                />
              )} */}
                {/* {item?.compliance_aid && (
                <Chips
                  className={classes.cursorMain}
                  rippleEffectEnabled={true}
                  click
                  label="Compliance"
                  color={
                    item?.status === "Absent" || item?.status === "Deceased"
                      ? "rgba(107, 107, 107,0.6)"
                      : "rgba(137, 156, 18, 0.6)"
                  }
                />
              )} */}
                {/* {item?.instalment_type && (
                <Chips
                  className={classes.cursorMain}
                  rippleEffectEnabled={true}
                  click
                  label={
                    InstallmentDispensingDetail[item?.instalment_type].label
                  }
                  color={
                    item?.status === "Absent" || item?.status === "Deceased"
                      ? "rgba(107, 107, 107,0.6)"
                      : "rgba(56, 91, 177, 0.6)"
                  }
                />
              )} */}
              </Box>
            </Box>
          )
        }
      </TableCell>

      {Object.keys(tableCells).map((columnName) => {
        return (
          <>
            {tableCells[columnName].show && (
              <>
                {columnName === "Nurse_Name" && (
                  <TableCell>
                    <Box
                      className={clsx(
                        classes.rsOrderDate,
                        item?.status === "Absent" || item?.status === "Deceased"
                          ? classes.rsPatientGreyInfo
                          : ""
                      )}
                    >
                      {item.n_name || "-"}
                    </Box>
                  </TableCell>
                )}
                {columnName === "dob" && (
                  <TableCell
                    className={clsx(
                      classes.rsOrderDate,
                      item?.status === "Absent" || item?.status === "Deceased"
                        ? classes.rsPatientGreyInfo
                        : ""
                    )}
                  >
                    {item?.dob
                      ? moment(new Date(item?.dob)).format("DD-MM-YYYY")
                      : // ||
                        //   "N / A"
                        !item?.dob && (
                          <>
                            <Box className="addme_effect"></Box>
                            <Chips
                              // className={classes.rsAddme}
                              color={"rgba(123, 192,  68,1)"}
                              variant={"filled"}
                              // color={""}
                              // variant={"outlined"}
                              textColor={"rgba(255,255,255,1)"}
                              borderColorChip={"rgba(123, 192,  68,1)"}
                              label="Add me"
                              // color={""}
                              // variant={"outlined"}
                              // borderColorChip={"rgba(123, 192,  68,1)"}
                              // textColor={"rgba(123, 192, 68,1)"}
                              width="58px"
                              onClick={() => {
                                setEditDobDate(item);
                                setIsOpenEditDobModel(true);
                              }}
                            />
                          </>
                        )}
                    {` `}

                    {item?.dob && (
                      <IconButton className={classes.rseditDateIcon}>
                        <PrimaryIcon
                          color="white"
                          width="20px"
                          icon={EditIcon}
                          cursor="pointer"
                          onClick={() => {
                            // setIsOrderRecordActionType("editOrderDate");
                            setEditDobDate(item);
                            setIsOpenEditDobModel(true);
                          }}
                        />
                      </IconButton>
                    )}
                  </TableCell>
                )}
                {columnName === "surgery_name" && (
                  <TableCell>
                    <HtmlTooltipMain
                      style={{ cursor: "pointer" }}
                      title={item?.surgery?.name}
                    >
                      <Box
                        className={
                          item?.status === "Absent" ||
                          item?.status === "Deceased"
                            ? classes.rsPatientGreyInfo
                            : classes.textInfo
                        }
                      >
                        {width > 1600
                          ? getEllipsisName(item?.surgery?.name, 30)
                          : getEllipsisName(item?.surgery?.name, 18)}
                      </Box>
                    </HtmlTooltipMain>
                  </TableCell>
                )}
                {!["pharmacist_staff", "pharmacy"].indexOf(
                  showDataBasedOnRole
                ) !== -1 &&
                  columnName === "pharmacy_name" && (
                    <TableCell
                      className={
                        item?.status === "Absent" || item?.status === "Deceased"
                          ? classes.rsPatientGreyInfo
                          : ""
                      }
                    >
                      {item?.pharmacy?.name || "-"}
                    </TableCell>
                  )}
                {columnName === "scheduled" && (
                  <TableCell>
                    {/* {item?.scheduled === "Yes" ? (
                      item?.status === "Absent" ||
                      item?.status === "Deceased" ? (
                        <Box className={classes.rsPatientGreyInfo}>-</Box>
                      ) : (
                        <HtmlTooltipMain title="Repeat Order">
                          <Box width={"fit-content"}>
                            <IconButton disabled>
                              <PrimaryIcon
                                color="primary"
                                width="20px"
                                icon={CalenderIcon}
                              />
                            </IconButton>
                          </Box>
                        </HtmlTooltipMain>
                      )
                    ) : (
                      <Box
                        className={
                          item?.status === "Absent" ||
                          item?.status === "Deceased"
                            ? classes.rsPatientGreyInfo
                            : ""
                        }
                      >
                        -
                      </Box>
                    )} */}
                    {item?.order_count > 0 ? (
                      <HtmlTooltipMain title="Repeat Order">
                        <Box width={"fit-content"}>
                          <IconButton disabled>
                            <PrimaryIcon
                              color="primary"
                              width="20px"
                              icon={CalenderIcon}
                            />
                          </IconButton>
                        </Box>
                      </HtmlTooltipMain>
                    ) : (
                      <Box
                        className={
                          item?.status === "Absent" ||
                          item?.status === "Deceased"
                            ? classes.rsPatientGreyInfo
                            : ""
                        }
                      >
                        -
                      </Box>
                    )}
                  </TableCell>
                )}
                {columnName === "address" && (
                  <TableCell>
                    <HtmlTooltipMain title={item?.address}>
                      <Box
                        className={
                          item?.status === "Absent" ||
                          item?.status === "Deceased"
                            ? classes.rsPatientGreyInfo
                            : classes.rsPatientGreyInfoAddress
                        }
                      >
                        {item?.address
                          ? // ? getEllipsisName(item?.address, 25)
                            item?.address
                          : "-"}
                      </Box>
                    </HtmlTooltipMain>
                    {/* {item?.address || "-"} */}
                  </TableCell>
                )}
                {columnName === "group" && (
                  <TableCell
                    className={
                      item?.status === "Absent" || item?.status === "Deceased"
                        ? classes.rsPatientGreyInfo
                        : ""
                    }
                  >
                    {item?.g_name || "-"}
                  </TableCell>
                )}
              </>
            )}
          </>
        );
      })}

      <TableCell className="table-action">
        <Box display={"flex"}>
          <HtmlTooltipMain title="View Notes" className="hoverAlign">
            <IconButton
              onClick={() => {
                setShowPatientNoteList(item?.id);
                setOpenPatientNoteList(true);
              }}
            >
              <PrimaryIcon width="20px" icon={NoteIcon} cursor="pointer" />
            </IconButton>
          </HtmlTooltipMain>
          <HtmlTooltipMain title="Medication History" className="hoverAlign">
            <IconButton
              title="Compliance"
              // className="iconBtn"
              onClick={() => {
                setOpenPatientHistory(true);
                setPatientHistory(item?.id);
              }}
            >
              <PrimaryIcon
                color="primary"
                width="20px"
                height="20px"
                icon={HistoryIcon}
              />
            </IconButton>
          </HtmlTooltipMain>
          <HtmlTooltipMain title="Edit Patient" className="hoverAlign">
            <IconButton
              onClick={() => {
                navigate(`/patients?actionType=edit&patientId=${item?.id}`);
              }}
            >
              <PrimaryIcon
                color="primary"
                width="20px"
                icon={EditIcon}
                cursor="pointer"
              />
            </IconButton>
          </HtmlTooltipMain>
          <HtmlTooltipMain title="Delete" className="hoverAlign">
            <IconButton
              onClick={() => {
                setDeletePatient(true);
                setPatientDeleteId(item?.id);
                setOrderCount(item?.order_count);
                setCollectionCount(item?.rxes_count);
              }}
            >
              <PrimaryIcon width="20px" icon={DeleteIcon} cursor="pointer" />
            </IconButton>
          </HtmlTooltipMain>
        </Box>
      </TableCell>
    </TableRow>
  );
};

const mapStateToProps = (state) => ({
  patientList: state.patient.patientList,
  deletePatientData: state.patient.deletePatientData,
  patientNoteList: state.patient.patientNoteList,
  createPatientNoteData: state.patient.createPatientNoteData,
  updatePatientNoteData: state.patient.updatePatientNoteData,
  deletePatientNoteData: state.patient.deletePatientNoteData,
  singlePatientNoteData: state.patient.singlePatientNoteData,
  patientMedicationHistoryList: state.patient.patientMedicationHistoryList,
});
const mapDispatchToProps = (dispatch) => ({
  getPatientStatusUpdatAction: (id, payload) =>
    dispatch({ type: START_STATUS_PATIENT_UPDATE, id, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PatientTable);
